<template>
  <div id="legalNotice" class="d-flex flex-column justify-content-end align-items-left" v-if="legalNoticeLg.lg1.length > 0">
    <div id="bloc1" v-if="legalNoticeLg.lg1">
      <div class="lg1 subtitle" v-html="rawHtml(legalNoticeLg.lg1[0].ta_value)"></div>
    </div>
    <div id="bloc2" v-if="legalNoticeLg.lg1.length > 1">
      <div v-if="legalNoticeLg.lg1.length > 2">
        <div class="lg1 subtitle" v-html="rawHtml(legalNoticeLg.lg1[2].ta_value)"></div>
      </div>
    </div>
    <div id="bloc3" v-if="legalNoticeLg.lg1.length > 3">
      <div class="lg1 subtitle" v-html="rawHtml(legalNoticeLg.lg1[3].ta_value)"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MercureRatesHorizontalV1LegalNoticeLeft',
  props: {
    legalNoticeLg: Object
  },
  methods: {
    rawHtml (value) {
      return value
    }
  }
}
</script>


<style lang="scss" scoped>
  $srcWidth: 1920;
  $srcHeight: 1200;
  @import "../../../../_ibisstyles.scss";

  #legalNotice {
    font-family: "Gotham-Book";
    @include fontSize(27);
    line-height: 1.2em;

    position: absolute;
    bottom: 45px;
    @include widthPercent(939);
    @include heightPercent(96);

    .subtitle::first-letter {
      text-transform: uppercase;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ibisstyles/rates/horizontal/v1/rates/legalNoticeLeft.vue